/*
 * Project: forca
 * File Created: Monday, 14th February 2022 3:40:53 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Portal } from 'react-portal';

import { startTimeout, endTimeout } from './notification.config';

import { NotificationComponentProps } from './notification.definition';

export const Notification = (props: NotificationComponentProps) => {
	const { message, isError = false, isInfo = false } = props;
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setIsActive(true);
		}, startTimeout);

		setTimeout(() => {
			setIsActive(false);
		}, endTimeout);
	}, []);

	const isHTML = message?.indexOf('<p>') > -1;

	return (
		<Portal>
			<div
				className={ [
					'site-message',
					isActive ? 'site-message--active' : '',
					isError ? 'site-message--danger' : '',
					isInfo ? 'site-message--info' : ''
				].join(' ') }
			>
				{ isHTML ? parse(message) : <p>{ message }</p> }
			</div>
		</Portal>
	);
};

export default Notification;